export const CELIA_MEETING_URL =
  "https://meetings.hubspot.com/celia-desailly?uuid=55b5935b-62cf-4b9c-88af-39e02f81e4e9";

export const CELIA_MEETING_EMBED_URL = `${CELIA_MEETING_URL}&embed=true`;

const LOCALE_MAP: Record<string, string> = {
  fr: "fr",
  en: "en",
  es: "es",
  de: "de",
  nl: "nl",
};

export const getCeliaMeetingEmbedUrl = (lang?: string) => {
  const locale = LOCALE_MAP[lang ?? "fr"] ?? "fr";
  return `${CELIA_MEETING_URL}&embed=true&locale=${locale}`;
};
